module.exports = __webpack_public_path__ + "img/asset-library-icon.5ea8f181.svg";